/**
 * Payment System Configuration
 * 
 * To disable test mode banner in production:
 * Change IS_TEST_MODE to false before deploying to production
 */

export const PAYMENT_CONFIG = {
  // Set to false when going live
  IS_TEST_MODE: true,
  
  // Provider info
  PROVIDER: 'iyzico',
  
  // API endpoints (will be overridden by environment variables)
  API_URL: process.env.REACT_APP_API_URL || 'https://www.minelakids.com/api',
};

export default PAYMENT_CONFIG;
